/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePremiumSchedulePayloadDto
 */
export interface UpdatePremiumSchedulePayloadDto {
    /**
     * New NOC status
     * @type {string}
     * @memberof UpdatePremiumSchedulePayloadDto
     */
    nocStatus?: UpdatePremiumSchedulePayloadDtoNocStatusEnum;
    /**
     * Premium closing check
     * @type {boolean}
     * @memberof UpdatePremiumSchedulePayloadDto
     */
    closing: boolean;
    /**
     * Closing reference number
     * @type {string}
     * @memberof UpdatePremiumSchedulePayloadDto
     */
    closingReference?: string;
}


/**
 * @export
 */
export const UpdatePremiumSchedulePayloadDtoNocStatusEnum = {
    NocDue: 'NOC Due',
    NocIssued: 'NOC Issued',
    Paid: 'Paid',
    Cancelled: 'Cancelled',
    ExtensionGranted: 'Extension Granted'
} as const;
export type UpdatePremiumSchedulePayloadDtoNocStatusEnum = typeof UpdatePremiumSchedulePayloadDtoNocStatusEnum[keyof typeof UpdatePremiumSchedulePayloadDtoNocStatusEnum];


/**
 * Check if a given object implements the UpdatePremiumSchedulePayloadDto interface.
 */
export function instanceOfUpdatePremiumSchedulePayloadDto(value: object): value is UpdatePremiumSchedulePayloadDto {
    if (!('closing' in value) || value['closing'] === undefined) return false;
    return true;
}

export function UpdatePremiumSchedulePayloadDtoFromJSON(json: any): UpdatePremiumSchedulePayloadDto {
    return UpdatePremiumSchedulePayloadDtoFromJSONTyped(json, false);
}

export function UpdatePremiumSchedulePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePremiumSchedulePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nocStatus': json['nocStatus'] == null ? undefined : json['nocStatus'],
        'closing': json['closing'],
        'closingReference': json['closingReference'] == null ? undefined : json['closingReference'],
    };
}

export function UpdatePremiumSchedulePayloadDtoToJSON(json: any): UpdatePremiumSchedulePayloadDto {
    return UpdatePremiumSchedulePayloadDtoToJSONTyped(json, false);
}

export function UpdatePremiumSchedulePayloadDtoToJSONTyped(value?: UpdatePremiumSchedulePayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nocStatus': value['nocStatus'],
        'closing': value['closing'],
        'closingReference': value['closingReference'],
    };
}

